
<template>
  <div class="content">

    <card>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="d-flex justify-content-between mt-0">
                <span>
                  Bildiriler Pdf
                  <small
                    class="small text-primary"
                  >(Sürükle-Bırak yaparak sıralamayı değiştirebilirsiniz)</small>
                </span>

                <div class="d-flex">
                  <button class="mr-2 btn btn-danger btn-sm btn-fill" v-on:click="addNew()">Ekle</button>
                  <button class="btn btn-primary btn-sm btn-fill" v-on:click="update()">Kaydet</button>
                </div>
              </h4>
              <draggable v-model="slider" :options="{animation:200}">
                <transition-group>
                  <div v-for="(item, index) in slider" :key="index+1">
                    <div class="card mb-2 menu-item">
                      <div class="card-body row">
                        <!-- <div class="col-2">
                        <img class="img-fluid" :src="mediaURL() + item.image">
                        </div>-->
                        <div class="col-9">
                          <div class="row w-100">
                            <div class="col-12 col-md-2 d-flex align-items-center">
                              <!-- <label>PDF</label> -->
                              <!-- <input type="text" name v-model="item.title" class="form-control" /> -->
                              <button :disabled="!item.image" type="submit" class="btn btn-warning activebtn-s mr-2 px-2">
                                <a v-if="item.image"
                                  :href="generalURL('haberler')+item.image"
                                  class="text-warning"
                                  target="_blank"
                                >PDF AÇ</a>
                                <span class="text-danger text-light pdf-alert-text" v-if="!item.image">Pdf Yüklenmedi</span>
                              </button>
                              <!-- <a href="http://buzpateni.sandbox/uploads/pdf/sample.pdf" target="_blank">PDF</a> -->
                            </div>
                            <div class="col-12 col-md-9">
                              <label>Açıklama</label>
                              <input
                                type="text"
                                name
                                v-model="item.target_url"
                                class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-1 d-flex justify-content-end align-items-center">
                          <div class="d-flex flex-column">
                            <button
                              title="PDF Değiştir"
                              @click="myPdf(item.id,index,0)"
                              class="btn btn btn-sm"
                            >
                              <i class="fas fa-image fa-fw"></i>
                            </button>
                                                          <input name="myFile" :id="'myPdf'+index" class="m-3" type="file" v-on:change="upload($event)" style="display:none"/>

                            <button v-on:click="remove(item.id)" class="btn btn-danger btn-sm mt-1">
                              <i class="fas fa-times fa-fw"></i>
                            </button>
                          </div>

                          <!-- <img v-bind:src="newSliderImage.cropped" class="img-fluid mt-4 border border-secondary p-2 d-none"> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import { ModelSelect } from "vue-search-select";

export default {
  data: function() {
    return {
      slider: [
        {
          image: null,
          title: null,
          description: null,
          target_url: null,
          image_type: 'newspdf'+this.$route.params.id,
          order_number: null
        }
      ],
      fullName : '',
      selectedType: null,
      types: ["URL", "Kategori", "Alt Kategori", "Yayın", "Etiket"],
      options: [],
      sliderItems: null,
      newPdf: {
        Pdf_id: null,
        Pdf_name: null,
        PdfIndex: null
      },

      total: 0,
      limit: localStorage.getItem("filterLimit"),
      page: 1,
      pageCount: null,
      navigation: true,
      type: "all",
      viewCounts: []
    };
  },
  components: {
    Card,
    ModelSelect
  },

  methods: {
            remove: function (id) {
              if(confirm("Silmek İstediğinize eminmisiniz?")){
        this.$http.delete("/api/images/delete/" + id).then(
          response => {
             this.notifier('top', 'right', 'danger', 'PDF Başarıyla silindi')
            this.getSlider();
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
      }},
    upload: function(event) {
  
      let file = event.target.files[0];
      if (file.type !== "application/pdf") return console.log(file);
      let data = new FormData();
      data.append("file", file);
      let newfile = file.name.split('.');
      let extension = '';
      let name = '';
      newfile.forEach((e,index)=>{
        if(index<newfile.length-1){
          name += e;
        }
        if(index==newfile.length-1){
          extension += e;
        }
      });

       let newName = name + new Date().getTime();
      this.fullName = newName+'.'+extension;
      data.append("fileName", this.fullName);

      this.$http.post("/api/files/upload-news-pdf/"+this.newPdf.Pdf_name , data).then(
         response => {
             var i = this.newPdf.n === 0 ? 'image' : 'image2';
          this.slider[this.newPdf.PdfIndex][i] = this.newPdf.Pdf_name;
          console.log(this.newPdf.Pdf_name)
           this.notifier('top', 'right', 'success', 'Pdf Başarıyla Yüklendi')
           this.update()
         },
         er => {
           this.notifier(
             "top",
             "right",
             "danger",
             "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
           );
         }
       );
    },
        myPdf:function(id,i, n){
        this.newPdf.Pdf_id = id
        if(this.slider[i].target_url){
          this.newPdf.Pdf_name = this.slugify(this.slider[i].target_url)+new Date().getTime()+'.pdf' 
        }else{
          this.newPdf.Pdf_name = 'bildiriler'+new Date().getTime()+'.pdf'
        }
        this.newPdf.PdfIndex = i
        this.newPdf.n = n;
        console.log(this.newPdf)
      document.getElementById('myPdf'+i).click()
    },
          addNew: function () {
        this.slider.push({
          image: null,
          title: null,
          description: null,
          target_url: null,
          image_type: 'newspdf'+this.$route.params.id,
          order_number: null
        });
      },
      update: function(){
        var newdis = this
         this.slider.forEach(function (s) {
          if (!s.image) s.image = s.image2
          s.image_type = 'newspdf'+newdis.$route.params.id;
        });
        this.$http.post('/api/images/edit/', this.slider).then(
          response => {
            this.notifier('top', 'right', 'success', 'Değişiklikler Kaydedildi')
            this.getSlider()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          })
      },
    getSlider: function() {
      var url = "/api/images/newspdf/"+this.$route.params.id;
      this.$http.get(url).then(
        response => {
          this.slider = response.body;
        },
        er => {
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
        }
      );
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSlider();
    });
  }
};
</script>
<style>
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}
.pdf-alert-text{
  font-size: 14px;
}
.bg-gray {
  background-color: #bdc3c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/NewsPdfsModules/NewsPdfs.vue